import { render, staticRenderFns } from "./AdminSettingRustici.vue?vue&type=template&id=dfae8028&scoped=true&"
import script from "./AdminSettingRustici.vue?vue&type=script&lang=js&"
export * from "./AdminSettingRustici.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingRustici.vue?vue&type=style&index=0&id=dfae8028&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfae8028",
  null
  
)

export default component.exports